import { FC } from 'react';

/**
 * 답례품 순번 강조 칩. "#N번째" 통일 디자인 (red 톤).
 * 다건수신 안내 (`ShareConfirmModal`) / 의심 확인 모달 (`SuspicionConfirmModal`)
 * 에서 본인/충돌 양쪽 모두 동일한 모양으로 사용한다.
 */
export const SeqChip: FC<{ seq: number }> = ({ seq }) => (
  <span className="inline-flex items-center rounded-md bg-red-100 px-2 py-0.5 text-base font-bold text-red-700">
    #{seq}번째
  </span>
);
